import { createRoot } from 'react-dom/client';
import { ConfigProvider, App as AntApp } from 'antd';
import theme from './config/theme';
import App from './App';
import './styles/global.css';
import './styles/antOverrides.css';

const root = createRoot(document.getElementById('root'));

root.render(
  <ConfigProvider theme={theme}>
    <AntApp>
      <App />
    </AntApp>
  </ConfigProvider>
);
